import React, { useCallback, useMemo, useState } from 'react'
import { AppBtnColor, AppBtnSize } from '../../../components/btn/AppBtn'
import { FileUploadDishPopup } from './components/FileUploadDishPopup'
import { AppTitlePage } from '../../../components/AppTitlePage'
import { IChooseItems } from '../../../components/mainContent/TableAllDishes'
import { useNavigate } from 'react-router'
import { AllRoutes } from '../../../core/routes/AllRoutes'
import { useGetBuffetDishSimpleListQuery } from '../../../core/api/BuffetDishApi'
import { IBuffetDishDto } from '../../../core/api/dto/BuffetDishDto'
import { AppFilterDropdown } from '../../../components/AppDropdown/AppFilterDropdown'
import { useSearchParams } from 'react-router-dom'
import { AppFilterMultiDropdownWithPagination } from '../../../components/AppDropdown/AppFilterMultiDropdownWithPagination'
import { useGetCategoryQuery } from '../../../core/api/CategoryApi'
import { ICategory } from '../../../core/api/dto/CategoriesObjDto'
import { AppLoader, LoaderType } from 'components/AppLoader'
import { setFullTime } from './CreateDishPage'
import { IBaseSimpleList } from '../../../core/api/dto/BaseDto'
import { AppTableImageViewer } from '../../../components/AppTableImageViewer/AppTableImageViewer'
import { ImagePreviewWrapperSizeEnum } from 'UiKitComponents/ImagePreviewWrapper/ImagePreviewWrapper'
import {
  AppTableAlignType,
  AppTableLink,
} from '../../../components/AppTable/components/AppTableLink'
import { AppTableNumberBlock } from '../../../components/AppTable/components/AppTableNumberBlock'
import { AppTableMobile } from '../../../components/AppTable/AppTableMobile'
import { useTranslation } from 'react-i18next'
import { useGetWidth } from 'utils/useGetWidth'
import { AppStationPopup } from '../../../entities/AppStationPopup/AppStationPopup'
import { useDeleteDish } from './hooks/useDeleteDish'
import { useStartParamsDish } from './hooks/useStartParamsDish'
import { useLoadDishesFromSh } from './hooks/useLoadDishesFromSh'
import { useGetBuffetDishData } from './hooks/useGetBuffetDishData'
import { useSentOnFotobox } from './hooks/useSentOnFotobox'
import { AppDeleteFromMainServerPopup } from '../../../entities/AppDeleteFromMainServerPopup/AppDeleteFromMainServerPopup'
import { AppFilterEdgeServersList } from '../../../entities/AppFilterEdgeServersList/AppFilterEdgeServersList'

const headerData = [
  { title: 'Наименование', colWidth: '20%', sort: 'name' },
  { title: 'Категория', colWidth: '15%', sort: 'category__name' },
  { title: 'Статус', colWidth: '8%', sort: 'archived' },
  { title: 'Вес Эталонный, кг', colWidth: '10%', sort: 'standard_weight' },
  {
    title: 'Отклонение эталонного веса, кг',
    colWidth: '15%',
    sort: 'standard_deviation',
  },
  {
    title: 'Время реализации, ч:мин',
    colWidth: '12%',
    sort: 'implementation_period',
  },
  {
    title: 'Температура Эталонная, °C',
    colWidth: '10%',
    sort: 'standard_temp_min,standard_temp_max',
  },
  { title: 'Эталонное фото', colWidth: '5%' },
]

const archivedFilterData = [
  { name: 'Активно', value: 0 },
  { name: 'Удалено', value: 1 },
]

export const DishesPage = () => {
  const { t } = useTranslation()
  const [, setSearchParams] = useSearchParams()
  const { width } = useGetWidth()

  const {
    buffetDishesData,
    isFetchingGet,
    isLoadingGet,
    pageParams,
    unloadDishesHandler,
    isLoadingLocal,
  } = useGetBuffetDishData()

  const navigate = useNavigate()
  const [isFiltersOpen, setIsFiltersOpen] = useState(true)
  const [uploadFilePopup, setUploadFilePopup] = useState<boolean>(false)
  const [chooseItems, setChooseItems] = useState<IChooseItems | null>(null)

  const {
    deletePopup,
    onDeletePopupHandler,
    onDeleteHandler,
    closeDeletePopup,
  } = useDeleteDish(chooseItems, setChooseItems)
  const setIsLoadDishesFromShHandler = useLoadDishesFromSh()

  const [tableData, setTableData] = useState<IBuffetDishDto[]>([])
  const {
    sentPopup,
    closeSentPopup,
    openSentPopup,
    openDeleteStationPopup,
    onSendDishes,
    deleteStations,
    isDeleteMode,
    onDeleteStationDishes,
    isLoadingSend,
  } = useSentOnFotobox({
    tableData,
    chooseItems,
    setChooseItems,
  })

  const tableActions = [
    {
      title: 'Удалить',
      ico: 'basket',
      onClick: onDeletePopupHandler,
    },
    ...(process.env.REACT_APP_TYPE_SERVER === 'MainServer'
      ? [
          {
            title: 'Отправить на станцию',
            ico: 'add',
            onClick: openSentPopup,
          },
        ]
      : []),
  ]

  const clearFilterHandler = useCallback(() => {
    setSearchParams('limit=40')
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const openUploadFilePopupHandler = useCallback(() => {
    setUploadFilePopup(true)
  }, [])

  useStartParamsDish(setSearchParams)

  const actions = useMemo(
    () => [
      {
        btnTitle: '',
        btnIco: 'reload',
        sized: AppBtnSize.onlyIco,
        onClick: setIsLoadDishesFromShHandler,
        color: AppBtnColor.violetWhite,
      },
      {
        btnTitle: 'Загрузить',
        btnIco: 'import',
        onClick: openUploadFilePopupHandler,
        color: AppBtnColor.whiteOutlineViolet,
      },
      {
        btnTitle: 'Выгрузить',
        btnIco: 'export',
        onClick: unloadDishesHandler,
        color: AppBtnColor.whiteOutlineViolet,
      },
      {
        btnTitle: 'Добавить блюдо',
        btnIco: 'add',
        onClick: () => navigate(AllRoutes.addDishes.path),
        color: AppBtnColor.whiteOutlineViolet,
      },
      {
        btnTitle: 'Сбросить фильтр',
        onClick: clearFilterHandler,
        color: AppBtnColor.extraVioletViolet,
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [navigate, pageParams, isFiltersOpen],
  )
  if (!buffetDishesData) {
    return null
  }

  return (
    <React.Fragment>
      {isLoadingLocal && <AppLoader loaderType={LoaderType.main} />}
      {uploadFilePopup && (
        <FileUploadDishPopup setActive={setUploadFilePopup} />
      )}
      {deletePopup && (
        <AppDeleteFromMainServerPopup
          onClose={closeDeletePopup}
          onDelete={onDeleteHandler}
          onOpenStationPopup={openDeleteStationPopup}
        />
      )}
      {sentPopup && (
        <AppStationPopup
          onClose={closeSentPopup}
          isLoading={isLoadingSend}
          onSendItems={onSendDishes}
          isDeleteMode={isDeleteMode}
          deleteStations={deleteStations}
          onDeleteStationDishes={onDeleteStationDishes}
        />
      )}
      <div className={'width-for-page-wrapper'}>
        <AppTitlePage
          title="Блюда"
          actions={actions}
          isFiltersOpen={isFiltersOpen}
          setIsFiltersOpen={setIsFiltersOpen}
        />
        {isFiltersOpen && (
          <div className="filter-block mt-20">
            <div className={width <= 500 ? 'col-4' : ''}>
              <AppFilterMultiDropdownWithPagination<
                IBaseSimpleList,
                keyof IBaseSimpleList
              >
                searchParam={'ids'}
                id={'ids'}
                getterData={useGetBuffetDishSimpleListQuery}
                propToShowInList={'name'}
                valuePropName={'id'}
                label={'Названия блюд'}
                placeholder={'Выбрать'}
                fullWidth
              />
            </div>
            <AppFilterMultiDropdownWithPagination<ICategory, keyof ICategory>
              searchParam={'category'}
              id={'-category'}
              getterData={useGetCategoryQuery}
              propToShowInList={'name'}
              valuePropName={'id'}
              label={'Категория'}
              placeholder={'Выбрать'}
            />
            <AppFilterDropdown
              withTranslate
              id={'-archived'}
              searchParam={'archived'}
              data={archivedFilterData}
              valuePropName={'value'}
              propToShowInList={'name'}
              label={'Статус'}
              placeholder={'Выбрать'}
              minHeight
            />
            <AppFilterEdgeServersList />
          </div>
        )}
        <AppTableMobile
          data={buffetDishesData}
          headerData={headerData}
          chooseActions={tableActions}
          chooseMode
          chooseItems={chooseItems}
          setChooseItems={setChooseItems}
          setTableData={setTableData}
          idName={'dish'}
          tableDataSelectors={[
            {
              renderItem: (item) => {
                return (
                  <AppTableLink path={`${item.id}`} deleteItem={item.archived}>
                    <div className="clip-base">{item.name}</div>
                  </AppTableLink>
                )
              },
            },
            {
              renderItem: (item) => {
                return (
                  <AppTableLink path={`${item.id}`} deleteItem={item.archived}>
                    {item?.category?.name}
                  </AppTableLink>
                )
              },
            },
            {
              renderItem: (item) => {
                return item.archived ? (
                  <div className={`table-status delete`}>{t('Удалённый')}</div>
                ) : (
                  <AppTableLink path={`${item.id}`} deleteItem={item.archived}>
                    <div className={`table-status`}>{t('Активный')}</div>
                  </AppTableLink>
                )
              },
            },
            {
              renderItem: (item) => {
                return (
                  <AppTableLink
                    path={`${item.id}`}
                    deleteItem={item.archived}
                    align={AppTableAlignType.right}
                  >
                    <AppTableNumberBlock
                      value={
                        item?.standardWeight
                          ?.toFixed(3)
                          .toString()
                          .replace(/[.]/g, ',') || ''
                      }
                    />
                  </AppTableLink>
                )
              },
            },
            {
              renderItem: (item) => {
                return (
                  <AppTableLink
                    path={`${item.id}`}
                    deleteItem={item.archived}
                    align={AppTableAlignType.right}
                  >
                    <AppTableNumberBlock
                      value={
                        item?.standardDeviation
                          ?.toFixed(3)
                          .toString()
                          .replace(/[.]/g, ',') || ''
                      }
                    />
                  </AppTableLink>
                )
              },
            },
            {
              renderItem: (item) => {
                return (
                  <AppTableLink
                    path={`${item.id}`}
                    deleteItem={item.archived}
                    align={AppTableAlignType.right}
                  >
                    {`${
                      item.implementationPeriodRepresent
                        ? setFullTime(item.implementationPeriodRepresent)
                        : ''
                    }`}
                  </AppTableLink>
                )
              },
            },
            {
              renderItem: (item) => {
                return (
                  <AppTableLink
                    path={`${item.id}`}
                    deleteItem={item.archived}
                    align={AppTableAlignType.right}
                  >
                    <React.Fragment>
                      <AppTableNumberBlock
                        isTemp
                        value={item.standardTempMin ?? ''}
                      />{' '}
                      <span className="pl-4 pr-4"> - </span>
                      <AppTableNumberBlock
                        isTemp
                        value={item.standardTempMax ?? ''}
                      />
                    </React.Fragment>
                  </AppTableLink>
                )
              },
            },
            {
              renderItem: (item) => {
                return (
                  <AppTableImageViewer
                    imgPreview={item?.imagePreviewOnS3 || item.imagePreview}
                    image={item?.imageOnS3 || item.image}
                    imageName={item.name}
                    archived={item.archived}
                    size={ImagePreviewWrapperSizeEnum.MEDIUM}
                  />
                )
              },
            },
          ]}
          isLoading={isLoadingGet || isFetchingGet}
        />
      </div>
    </React.Fragment>
  )
}
